import { useMatchBreakpoints } from '@library/uikit'
import { MENU_HEIGHT, MENU_HEIGHT_MOBILE } from '@library/uikit/src/widgets/Menu/config'
import Container from 'components/Layout/Container'
import React, { ReactElement } from 'react'
import { HeaderBackground } from '../../Home/components/Banners/Styled'
import Hero from './Hero'
import IfoLayout from './IfoLayout'
import IgoQuestions from './IgoQuestions'

interface TypeProps {
  igoSection: ReactElement
}

const IgoContainer: React.FC<TypeProps> = ({ igoSection }) => {
  const { isMobile } = useMatchBreakpoints()
  return (
    <IfoLayout pt={isMobile ? MENU_HEIGHT_MOBILE : MENU_HEIGHT} id="current-ifo">
      <HeaderBackground />
      <Hero />
      <Container>{igoSection}</Container>
      <Container>
        <IgoQuestions />
      </Container>
    </IfoLayout>
  )
}

export default IgoContainer
